// DashLayout.js
import React from 'react';
// import Navbar  from "../components/Navbar";
import Footer from '../components/Footer';
// import Navbar2 from '../components/Navbar2'
function Layout({ children }) {
    return (
        <div>
            {/* <Navbar/> */}
            {children}
            <Footer/>
        </div>
        
    );
}

export default Layout;
